import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { GenService } from 'app/shared/gen-ser.service';
import { DataService } from 'app/shared/dataservice.service';
import { ActivatedRoute, Params } from '@angular/router';
import { DailyToken, FinishedGoodsDaily, DailyTokenItem } from 'app/shared/misc-classes';

@Component({
  selector: 'app-finished-goods',
  templateUrl: './finished-goods.component.html',
  styleUrls: ['./finished-goods.component.css']
})
export class FinishedGoodsComponent implements OnInit {

  selectedDayIndex: number = 0;
  selView: number = 1;
  isFullScrDaySel: boolean = true;
  isLoading: boolean = false;
  isLoaded: boolean = false;
  isFailed: boolean = false;
  areChangesMade: boolean = false;
  failMessage: string = '';
  hasmodaccess: boolean = false;
  daywiseItemList: Array<DailyToken>;
  fgDailyArray:Array<FinishedGoodsDaily>;//datatables
  fgCurrentDayObj:FinishedGoodsDaily;

  mId: string = "7371ba17-9f08-4da1-6fc0-f2f7c9686504";

  currMonthDtObj: Date = new Date();

  constructor(private _dataService: DataService, private _activatedRoute: ActivatedRoute, private _notify: NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Finished Goods";
    // this._activatedRoute.queryParams.subscribe((params: Params) => {
    //   if (params['month']) {
    //     this.currMonthDtObj = new Date(parseInt(params['month']));
    //   }
    // });

    this.loadMonthData();
  }

  

  checkModAccess(): boolean {
    if (this._dataService.mAccess(this.mId) == true) {
      this.hasmodaccess = true;
    }
    else {
      this.hasmodaccess = false;
    }
    return this.hasmodaccess;
  }

  loadMonthData() {
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;

    this._dataService.loadStockInfoMonthly(this.currMonthDtObj).subscribe((_fgDailyArr: Array<FinishedGoodsDaily>) => {
      if (_fgDailyArr != null) {
        this.fgDailyArray = _fgDailyArr;

        let _tmpDailyTokenList: Array<DailyToken> = [];
        for (var i = 0; i < _fgDailyArr.length; i++) {
          let _tmpDate: Date = _fgDailyArr[i].date;
          let _tmpDailyTokens: Array<DailyTokenItem> = [];
          let _indexer: number = 0;
          // this.datatables.dayTokens[i].dateTokens.forEach((_tmpObj: CCRPSMToken) => {
            // _tmpDailyTokens.push(new DailyTokenItem(this.getDisplayTokenName(_fgDailyArr[i]), _fgDailyArr[i], ''));
            _tmpDailyTokens.push(new DailyTokenItem("Domestic Breaker: " +this.getDisplayNumber(_fgDailyArr[i].domesticBreaker),_fgDailyArr[i], ''));
            _tmpDailyTokens.push(new DailyTokenItem("Export Breaker: " +this.getDisplayNumber(_fgDailyArr[i].exportBreaker),_fgDailyArr[i], ''));
            _tmpDailyTokens.push(new DailyTokenItem("Magnetic Actuators: "+this.getDisplayNumber(_fgDailyArr[i].magneticActuator),_fgDailyArr[i], ''));
          //   _indexer++;
          // });
          _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
        }

        this.loadDateData();

        this.daywiseItemList = _tmpDailyTokenList;
        this.isLoaded = true;
        this.isLoading = false;
        this.isFailed = false;
      }
      else {
        this.daywiseItemList = null
        this.isLoaded = false;
        this.isLoading = false;
        this.isFailed = true;
        this.failMessage = "Failed to get data from database, try again";
      }
    });
  }
  getDisplayNumber(_tempNum:string):string{
    if(_tempNum != null){
      return _tempNum;
    }
    return "0";
  }
   loadDateData():void{
    let _currDateNum:number = Number(GenService.getDateFormatStr(this.currMonthDtObj,"YYYYMMDD"));
    if(this.fgDailyArray){
       this.fgCurrentDayObj = this.fgDailyArray.find((_tmpObj:FinishedGoodsDaily) =>{
        return _tmpObj.dateNum == _currDateNum;
      });

      if(this.fgCurrentDayObj == null){
        this.fgCurrentDayObj = new FinishedGoodsDaily(_currDateNum,"","","","0","0",[]);
        this.fgDailyArray.push(this.fgCurrentDayObj);
      }
    }
  }
  public prevMonthSel(): void {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  nextMonthSel() {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }
  getDisplayTokenName(_fgDaily: FinishedGoodsDaily): string {
    return _fgDaily.totalFGoodsQty + " (" + _fgDaily.totalRevenue + ")";
  }

  ItemSelected(_evntObj) {
    this.selView = 1;
    if(_evntObj.selDate){
      this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    }
    else{
      this.currMonthDtObj.setDate(_evntObj.date.getDate());
    }
    
    this.loadDateData();
  }

  validateData(): boolean {
    return true;
  }

  saveData(_sendMail: boolean) {

  }
  discardData() {

  }

  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }

  dataSelectionChanged(evntData){
    this.currMonthDtObj = evntData.date;
    this.loadDateData();
  }
  hasEditAccess(_pid: string) {
    return this._dataService.hasEditAccess(this.mId, _pid);
  }

  hasReadAccess(_pid: string) {
    return this._dataService.hasReadAccess(this.mId, _pid);
  }
}
